import React from "react";

const Cardcursopythonia = () => {

    return(
        <div className="w3-card-4 w3-margin w3-quarter livecard">
            <a href="curso-python-ia"><img className="card-image" src="curso-python-ia-2.jpeg" alt="Curso Python AI desde cero" width="100%"/></a> 
            <div className="container w3-padding-32" style={{ paddingLeft: '32px', paddingRight: '32px' }}>
            <h2>Curso Python IA</h2>
            <h5>La Inteligencia Artificial se utiliza cada día más y hacemos uso de ella sin saber que lo hacemos. Aprender a usar Python + IA desde cero te ayudará a participar en un futuro que ya ha llegado. No te quedes atrás.</h5>
            <div className="w3-flex" style={{alignItems:'center', flexDirection:'column'}}>
                <p className="w3-large">Saber más sobre el Curso Python IA Gratuito</p>
                <div className="circle w3-xxlarge w3-center"><a href="curso-python-ia" style={{ textDecoration: 'none' }}><strong>→</strong></a></div>
            </div>
            </div>
        </div>
        
    );
}

export default Cardcursopythonia;